import {authRequest} from './index.js'

export async function create_report(report){
  let data
  await authRequest.post(
    '/report/upload/' + report.id,
    { report },
    { headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_assessments(trait_id, term_taxonomy_id = null){
  let data
  let url = 'traits/' + trait_id + '/assessments/'
  if (term_taxonomy_id){
    url = url + term_taxonomy_id
  }
  await authRequest.get(
    url
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_assessment(assessment_id, params){
  let data
  await authRequest.get(
    '/assessments/' + assessment_id,
    {params}
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_assessment(assessment){
  let data
  await authRequest.post(
    '/assessments',
    { assessment },
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_assessment(assessment_id, assessment){
  let data
  await authRequest.patch(
    '/assessments/' + assessment_id,
    { assessment },
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_age_group_ass(trait_id, child_id){
  let data
  await authRequest.get(
    '/children/' + child_id
    + '/traits/' + trait_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_trait_assessment(id){
  let data
  await authRequest.get(
    'traits/' + id.trait +
    '/childrens/' + id.child +
    '/assessments',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_assessment_history(trait_id, child_id){
  let data
  await authRequest.get(
    'childrens/' + child_id +
    '/traits/' + trait_id +
    '/assessments_history',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function delete_assessment(assessment_id){
  let data
  await authRequest.delete(
    '/assessments/' + assessment_id,
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function import_csv(file, import_type, trait_id = null){
  let data
  let formData = new FormData()
  formData.append('file', file)
  formData.append('import_type', import_type)
  if (trait_id) {
    formData.append('trait_id', trait_id)
  }

  await authRequest.post(
    '/assessments/import',
    formData,
    { headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}